import Navbar from "./components/Navbar";
import FooterSection from "./components/FooterSection";

export default function NewFourAuditPage() {
  return (
    <div className="min-h-screen bg-[#fff8ef] text-[#171717] overflow-hidden">
      <div className="fixed inset-0 pointer-events-none opacity-70" style={{ background: "radial-gradient(circle at 12% 18%, rgba(89,170,255,0.24), transparent 18%), radial-gradient(circle at 82% 14%, rgba(255,126,78,0.18), transparent 20%), radial-gradient(circle at 74% 68%, rgba(255,205,82,0.18), transparent 18%)" }} />
      <Navbar />
      <main className="relative z-10 pt-[110px] pb-20">
        <section className="pb-12 border-b border-[#171717]/8">
          <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-[1fr_1fr] gap-8 items-center">
            <div>
              <p className="text-[11px] uppercase tracking-[0.24em] text-[#6b6b6b] font-bold mb-4">Service • Audit</p>
              <h1 className="text-5xl md:text-6xl font-black tracking-[-0.06em] leading-[0.94] mb-5">Find what is actually blocking AI visibility before you burn another quarter guessing.</h1>
              <p className="text-[#4f4f4f] text-lg leading-relaxed max-w-2xl mb-8">The AI Visibility Audit gives teams a sharper diagnosis across discoverability, entity clarity, content reinforcement, and commercial readiness so the next move is grounded, not random.</p>
              <div className="flex flex-wrap gap-4">
                <button onClick={() => window.dispatchEvent(new Event("flowvory:open-strategy"))} className="px-7 py-4 rounded-full bg-[#171717] text-[#fff8ef] text-base font-bold shadow-[8px_8px_0_rgba(89,170,255,0.24)]">Book a Call</button>
                <div className="px-5 py-4 rounded-full bg-white/80 border border-[#171717]/10 text-sm font-semibold rotate-[-2deg]">For serious teams that want a roadmap, not a decorative deck</div>
              </div>
            </div>
            <div className="space-y-4">
              {[
                ["Entity clarity", "Can machines understand the brand cleanly?"],
                ["AI retrieval", "Does the business belong in answer surfaces yet?"],
                ["Conversion readiness", "If demand arrives, does the page actually convert?"],
              ].map(([title, text], idx) => (
                <div key={title} className={`rounded-[28px] border border-[#171717]/10 p-6 shadow-[0_18px_50px_rgba(23,23,23,0.05)] ${idx === 1 ? "bg-[#171717] text-white rotate-[1deg]" : idx === 2 ? "bg-[#dff3ff] rotate-[-1deg]" : "bg-white/86"}`}>
                  <h3 className="text-2xl font-black tracking-[-0.04em] mb-3">{title}</h3>
                  <p className={`leading-relaxed ${idx === 1 ? "text-white/76" : "text-[#4f4f4f]"}`}>{text}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 border-b border-[#171717]/8">
          <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-4 gap-4">
            {[
              ["01", "Discover", "Where the brand is weak or missing"],
              ["02", "Interpret", "Which structural issues create the weakness"],
              ["03", "Prioritize", "What matters most now"],
              ["04", "Sequence", "What should happen next and in what order"],
            ].map(([step, title, text], idx) => (
              <div key={step} className={`rounded-[28px] border border-[#171717]/10 p-5 shadow-[0_18px_50px_rgba(23,23,23,0.05)] ${idx === 1 ? "bg-[#dff3ff]" : idx === 2 ? "bg-[#fff0db]" : idx === 3 ? "bg-[#e8fff7]" : "bg-white/86"}`}>
                <div className="text-4xl font-black tracking-[-0.06em] mb-3">{step}</div>
                <h3 className="text-xl font-black tracking-[-0.04em] mb-2">{title}</h3>
                <p className="text-sm text-[#4f4f4f] leading-relaxed">{text}</p>
              </div>
            ))}
          </div>
        </section>
      </main>
      <FooterSection />
    </div>
  );
}
